import { EdgeLoadCurrentDocumentRepository } from '@/modules/legal/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadCurrentDocument } from '@/modules/legal/use-cases'

export function makeLoadCurrentDocument(): LoadCurrentDocument {
  return new EdgeLoadCurrentDocumentRepository(makeSupabaseEdgeHttpClient()).execute
}
